import React, { useMemo, useState } from "react";
import { Button } from "../ui/Button";
import { GripVertical, Settings2 } from "lucide-react";
import { Checkbox, Popover } from "@mui/material";
import { t } from "i18next";
import { SortableList } from "./SortableList";

function ColumnSort({
  sortedColumns,
  setSortedColumns,
  resetColumnSort,
  tableEntries,
  isLoadingData
}) {
  const [tableColumnSortAnchorEl, setTableColumnSortAnchorEl] = useState(null);
  const openTableColumnSort = (event) => {
    if(isLoadingData){
      return
    }
    setTableColumnSortAnchorEl(event.currentTarget);
  };

  const closeTableColumnSort = () => {
    setTableColumnSortAnchorEl(null);
  };

  function showAllColumns() {
    setSortedColumns((prev) =>
      prev.map((item) => ({ ...item, isVisible: true }))
    );
  }

  const columnNames = useMemo(() => {
    return Object.entries(tableEntries).map(([columnId, columnData]) => ({
      id: columnId,
      name: t(columnData.title),
    }));
  }, [tableEntries]);
  return (
    <>
      <Button variant="secondary" className="" onClick={openTableColumnSort}>
        <Settings2 size={18}></Settings2>
      </Button>
      <Popover
        open={Boolean(tableColumnSortAnchorEl)}
        anchorEl={tableColumnSortAnchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        onClose={closeTableColumnSort}
      >
        <div className="flex justify-between items-center gap-2 p-2 border-b border-gray-200 text-sm">
          <p className="m-0 text-xs font-bold">{t("table_columns")}</p>
          <Button
            variant="secondary"
            className="ml-auto"
            onClick={showAllColumns}
          >
            {t("all")}
          </Button>
          <Button variant="secondary" onClick={resetColumnSort}>
            {t("reset")}
          </Button>
        </div>
        <div className="list-none p-3 max-h-[300px] overflow-auto">
          <div className="flex items-center font-medium cursor-not-allowed opacity-70 text-sm">
            <GripVertical size={18}></GripVertical>{" "}
            <Checkbox checked={true} size="small" />
            {t("supplier_name")}
          </div>
          <SortableList
            items={sortedColumns}
            onSorted={(sortedItems) => {
              setSortedColumns(sortedItems);
            }}
            renderItem={(item) => (
              <div className="flex items-center cursor-grab font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm">
                <GripVertical size={18}></GripVertical>
                <Checkbox
                  checked={item.isVisible}
                  onChange={(e) => {
                    setSortedColumns((prev) => {
                      return prev.map((prevItem) => {
                        if (prevItem.id === item.id) {
                          return {
                            ...prevItem,
                            isVisible: e.target.checked,
                          };
                        }
                        return prevItem;
                      });
                    });
                  }}
                  size="small"
                />
                {columnNames?.find((column) => column.id === item.id)?.name}
              </div>
            )}
          ></SortableList>
        </div>
      </Popover>
    </>
  );
}

export default ColumnSort;
